import { render, staticRenderFns } from "./TagPicker.vue?vue&type=template&id=725b72c8&scoped=true"
import script from "./TagPicker.vue?vue&type=script&setup=true&lang=ts"
export * from "./TagPicker.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./TagPicker.vue?vue&type=style&index=0&id=725b72c8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "725b72c8",
  null
  
)

export default component.exports